const videoWebcams: NodeListOf<HTMLVideoElement> = document.querySelectorAll(".cam-video")
const videoWebcamsArray: HTMLVideoElement[] = Array.from(videoWebcams)

if (videoWebcamsArray.length === 0) {
    console.warn("No webcam videos found.")
}

if (videoWebcamsArray) {
    for (const video of videoWebcamsArray) {
        const videoClosestSibling = video.closest("a")?.nextElementSibling as HTMLElement | null
        const pauseButtonWebcams = videoClosestSibling?.querySelector(".video-pause") as HTMLElement | null
        const playButtonWebcams = videoClosestSibling?.querySelector(".video-play") as HTMLElement | null
        const volumeButtonWebcams = videoClosestSibling?.querySelector(".volume-control-slider") as HTMLElement | null
        const videoMuteButtonWebcams = videoClosestSibling?.querySelector(".video-mute") as HTMLElement | null
        const videoUnmuteButtonWebcams = videoClosestSibling?.querySelector(".video-unmute") as HTMLElement | null

        if (pauseButtonWebcams && playButtonWebcams) {
            pauseButtonWebcams.addEventListener("click", () => {
                video.pause()
                pauseButtonWebcams.style.display = "none"
                playButtonWebcams.style.display = "block"
            })
            playButtonWebcams.addEventListener("click", () => {
                video.play()
                playButtonWebcams.style.display = "none"
                pauseButtonWebcams.style.display = "block"
            })
        }

        if (videoMuteButtonWebcams && videoUnmuteButtonWebcams && volumeButtonWebcams) {
            videoMuteButtonWebcams.addEventListener("click", () => {
                video.muted = false
                video.removeAttribute("muted")
                videoMuteButtonWebcams.style.display = "none"
                videoUnmuteButtonWebcams.style.display = "block"
                volumeButtonWebcams.style.opacity = "1"
            })

            videoUnmuteButtonWebcams.addEventListener("click", () => {
                if (video) {
                    video.muted = true
                    video.setAttribute("muted", "muted")
                    videoMuteButtonWebcams.style.display = "block"
                    videoUnmuteButtonWebcams.style.display = "none"
                    volumeButtonWebcams.style.opacity = "0.15"
                }
            })

            volumeButtonWebcams.addEventListener("input", (event) => {
                const target = event.target as HTMLInputElement
                const volumeValue = Number.parseFloat(target.value) / 100
                video.volume = volumeValue
                video.muted = false
                video.removeAttribute("muted")
                volumeButtonWebcams.style.opacity = "1"
                videoMuteButtonWebcams.style.display = "none"
                videoUnmuteButtonWebcams.style.display = "block"
                if (volumeValue === 0) {
                    video.muted = true
                    video.setAttribute("muted", "muted")
                    volumeButtonWebcams.style.opacity = "0.15"
                    videoMuteButtonWebcams.style.display = "block"
                    videoUnmuteButtonWebcams.style.display = "none"
                }
            })
        }
    }
}
